import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import BreadcrumbsContext from './BreadcrumbsContext';
const withBreadcrumbs = (Component) => {
    const Hoc = (props) => {
        const rest = React.useContext(BreadcrumbsContext);
        return <Component {...rest} {...props}/>;
    };
    Hoc.displayName = `withBreadcrumbs(${Component.displayName || Component.name})`;
    return hoistNonReactStatics(Hoc, Component);
};
export default withBreadcrumbs;
